import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError } from "../../utils/api.types";

import {
    ICountryResponse,
    ICountries,
    ICountry
} from "../../utils/country.types";

/**
 * Fetch countries async thunk.
*/
export const fetchCountries = createAsyncThunk(
    'country/fetchCountries',
    async (): Promise<ICountry[]> => {
        const response = await axios.get(`/api/v1/countries`);
        return response.data.countries;
    }
);

